import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';

import {
  CASE_ID_PATTERN_SOURCE,
  CASE_URL_BASE
} from '@/constants/caseId.constants';

type RemarkNode = {
  type: string;
  value?: string;
  url?: string;
  children?: RemarkNode[];
};

const SKIPPED_PARENT_TYPES = new Set([
  'link',
  'linkReference',
  'inlineCode',
  'code',
  'definition',
  'html'
]);

export const remarkCaseIdLinks: Plugin = () => (tree) => {
  const pattern = new RegExp(`\\b(${CASE_ID_PATTERN_SOURCE})\\b`, 'g');

  visit(tree, 'text', (node, index, parent) => {
    const textNode = node as RemarkNode;
    const textParent = parent as RemarkNode | undefined;

    if (
      index === undefined ||
      !textParent?.children ||
      SKIPPED_PARENT_TYPES.has(textParent.type) ||
      !textNode.value
    ) {
      return;
    }

    pattern.lastIndex = 0;
    if (!pattern.test(textNode.value)) {
      return;
    }

    const replacementNodes: RemarkNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    pattern.lastIndex = 0;

    while ((match = pattern.exec(textNode.value)) !== null) {
      const caseId = match[1];

      if (match.index > lastIndex) {
        replacementNodes.push({
          type: 'text',
          value: textNode.value.slice(lastIndex, match.index)
        });
      }

      replacementNodes.push({
        type: 'link',
        url: `${CASE_URL_BASE}${caseId}`,
        children: [{ type: 'text', value: caseId }]
      });

      lastIndex = match.index + caseId.length;
    }

    if (lastIndex < textNode.value.length) {
      replacementNodes.push({
        type: 'text',
        value: textNode.value.slice(lastIndex)
      });
    }

    textParent.children.splice(index, 1, ...replacementNodes);
    return index + replacementNodes.length;
  });
};
